/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiMenuManagerMutationRequest,
  PutApiMenuManagerMutationResponse,
} from '../models/PutApiMenuManager.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiMenuManagerMutationResponseSchema,
  putApiMenuManagerMutationRequestSchema,
} from '../zod/putApiMenuManagerSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiMenuManagerMutationKey = () =>
  [{ url: '/api/menu/manager' }] as const;

export type PutApiMenuManagerMutationKey = ReturnType<
  typeof putApiMenuManagerMutationKey
>;

/**
 * {@link /api/menu/manager}
 */
export async function putApiMenuManager(
  data?: PutApiMenuManagerMutationRequest,
  config: Partial<RequestConfig<PutApiMenuManagerMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = putApiMenuManagerMutationRequestSchema.parse(data);
  const res = await request<
    PutApiMenuManagerMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiMenuManagerMutationRequest
  >({
    method: 'PUT',
    url: `/api/menu/manager`,
    data: requestData,
    ...requestConfig,
  });
  return putApiMenuManagerMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/menu/manager}
 */
export function usePutApiMenuManager<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiMenuManagerMutationResponse,
      ResponseErrorConfig<Error>,
      { data?: PutApiMenuManagerMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<PutApiMenuManagerMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiMenuManagerMutationKey();

  return useMutation<
    PutApiMenuManagerMutationResponse,
    ResponseErrorConfig<Error>,
    { data?: PutApiMenuManagerMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return putApiMenuManager(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
